var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const convertToContextUri_1 = __importDefault(require("../convertToContextUri"));
function getOrigin(requestOptions) {
    const { origin = 'https://inet.hendersonengineers.com' } = requestOptions;
    return (0, convertToContextUri_1.default)(origin);
}
exports.default = getOrigin;
//# sourceMappingURL=getOrigin.js.map